import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentFirstLevelMenu: null
  },
  getters: {
    currentFirstLevelMenu: state => state.currentFirstLevelMenu
  },
  mutations: {
    SET_CURRENT_FIRST_LEVEL_MENU(state, menu) {
      state.currentFirstLevelMenu = menu;
    }
  },
  actions: {
    // 根据路径查找并设置一级菜单
    findAndSetFirstLevelMenu({ commit }, { path, router }) {
      // 检查路径是否是某个路由的子路由
      const isChildRoute = (currentPath, route) => {
        if (!route.children) return false;
        
        // 检查是否是直接子路由
        const directChild = route.children.some(child => 
          currentPath === child.path || currentPath.startsWith(child.path + '/')
        );
        if (directChild) return true;
        
        // 递归检查更深层次的子路由
        return route.children.some(child => isChildRoute(currentPath, child));
      };
      
      // 查找对应路径的一级菜单
      const findFirstLevelMenu = (path) => {
        const adminRoutes = router.options.adminRoutes;
        if (!Array.isArray(adminRoutes)) return null;
        
        // 遍历所有一级菜单
        for (let i = 0; i < adminRoutes.length; i++) {
          const routeGroup = adminRoutes[i];
          
          if (Array.isArray(routeGroup)) {
            // 如果是二维数组，遍历每个子数组
            for (let j = 0; j < routeGroup.length; j++) {
              const route = routeGroup[j];
              if (route.path === path || 
                  (route.redirect && route.redirect === path) || 
                  isChildRoute(path, route)) {
                return route;
              }
            }
          } else {
            // 处理一维数组的情况
            if (routeGroup.path === path || 
                (routeGroup.redirect && routeGroup.redirect === path) || 
                isChildRoute(path, routeGroup)) {
              return routeGroup;
            }
          }
        }
        
        return null;
      };
      
      // 查找并设置对应的一级菜单
      const firstLevelMenu = findFirstLevelMenu(path);
      if (firstLevelMenu) {
        commit('SET_CURRENT_FIRST_LEVEL_MENU', firstLevelMenu);
      }
      
      return firstLevelMenu;
    }
  },
  modules: {
    user
  }
})
